import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getTagInfoforSupplier, getUserProfile } from "../services/api";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
    Box,
    Button,
    Container,
    Stack,
    TextField,
    Typography,
    Alert,
    CircularProgress,
    useMediaQuery,
} from "@mui/material";
import { useTranslation } from 'react-i18next';


const Supplier = () => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingButton, setloadingButton] = useState(false);
    const [loadingButton2, setloadingButton2] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:768px)");
    let OrderId;

    // Handle form field changes
    const handleInputChange = (value) => {
        OrderId = value;
    };

    const SubmitCheck = async () => {
        setloadingButton(true);
        getTagInfoforSupplier(OrderId)
            .then((response) => {
                if (response.status === 200) {
                    setloadingButton(false);
                    navigate(`/supplier-page?qr=${OrderId}`)
                }
            })
            .catch((error) => {
                console.error("Error fetching Tag Info:", error);
                setError("The Order Id does not exist!");
                setloadingButton(false);
            });
    }

    if (loading) {
        return (
            <Box
                sx={{
                    bgcolor: "#fcf8f3",
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        {/* 載入中... */}
                        <img src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif" alt=""
                            style={{
                                width: '150px',
                                height: 'auto',
                                mixBlendMode: 'multiply',
                            }} />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ bgcolor: "#fcf8f3", minHeight: "100vh" }}>
            {/* Header */}
            <Navbar />

            {/* Main Content */}
            <Container
                maxWidth="lg"
                sx={{
                    py: { xs: 4, md: 8 },
                    px: { xs: 2, md: 3 },
                    mt: "70px", // Add top margin to account for fixed navbar height
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        mb: { xs: 3, md: 5 },
                        fontWeight: "bold",
                        fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    }}
                >
                    Supplier Search Page / 供應商搜尋
                </Typography>

                {/* Error and Success Messages */}
                {error && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                        {error}
                    </Alert>
                )}

                <Stack
                    spacing={{ xs: 4, md: 6 }}
                    sx={{ maxWidth: { xs: "100%", sm: 400, md: 450 } }}
                >
                    <Stack spacing={{ xs: 2.5, md: 3 }}>
                        {/* Pet Name */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Enter Order Id / 輸入訂單編號:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="CUS-XXXXXXXXX"
                                onChange={(e) => handleInputChange(e.target.value)}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                            />
                        </Box>


                        <Button
                            variant="contained"
                            type="submit"
                            onClick={SubmitCheck}
                            sx={{
                                width: isMobile ? "100%" : "30%",
                                padding: "12px",
                                backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
                                color: "var(--color-black)",
                                border: "none",
                                borderRadius: "3px",
                                fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
                                fontWeight: "bold",
                                cursor: "pointer",
                                marginTop: "10px",
                                boxShadow: "none",
                                "&:hover": { background: "#FFB60C" },
                                "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                                cursor: loadingButton ? "not-allowed" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "10px",
                            }}
                            disabled={loadingButton}
                        >
                            Submit
                            {loadingButton && (
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <CircularProgress size={20} color="inherit" />
                                </span>
                            )}
                        </Button>

                    </Stack>
                </Stack>
            </Container>

            <Footer />
        </Box>
    );
};

export default Supplier;
